var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",class:{handle: !_vm.ingredientData.disablePick},style:(_vm.displayedStyle)},[_c('img',{attrs:{"src":_vm.ingredientData.image}})])}
var staticRenderFns = []

export { render, staticRenderFns }